import type { Middleware } from 'redux';

import {
  identifyPostHogUser,
  resetPostHogIdentity,
} from '@lib/analytics/posthogIdentity';
import { isPostHogLoaded, posthog } from '@lib/posthog.lib';

import {
  clearUserProfile,
  setImpersonatedUser,
  setUserProfile,
} from './slices/app/appSlice';

type AnalyticsAction = {
  type: string;
  payload?: UserDetail | number | null;
};

/**
 * Redux middleware that maps Casting App auth-related actions to PostHog
 * identify / reset / impersonation events.
 */
export const analyticsMiddleware: Middleware =
  () => (next) => (action: AnalyticsAction) => {
    const result = next(action);

    switch (action?.type) {
      case setUserProfile.type: {
        const profile = action.payload as UserDetail | undefined;

        identifyPostHogUser(
          profile?.id,
          profile?.email ? { email: profile.email } : undefined
        );
        break;
      }

      case setImpersonatedUser.type: {
        // Keep the admin's PostHog identity — they are the person using the
        // app. Only record which target was impersonated for context.
        const impersonatedTargetId = action.payload;

        if (isPostHogLoaded() && typeof impersonatedTargetId === 'number') {
          posthog.capture('Impersonation Started', {
            impersonated_target_id: String(impersonatedTargetId),
          });
        }

        break;
      }

      case clearUserProfile.type:
        resetPostHogIdentity();
        break;

      default:
        break;
    }

    return result;
  };
